import styled from "styled-components";

import UpdateButton from "@EditArticleContainer/shared/components/UpdateButton/UpdateButton";

export const ParagraphFinancialTermsLASCWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const ParagraphFinancialTermsLASCUpdateButton = styled(UpdateButton)`
  position: absolute;
  left: -1.6rem;
  top: 0;
  transform: translateX(-100%);
`;
